export const UPDATE_CARD_STATUS_START = 'UPDATE_CARD_STATUS_START';
export const UPDATE_CARD_STATUS_SUCCESS =
  'UPDATE_CARD_STATUS_SUCCESS';
export const UPDATE_CARD_STATUS_ERROR = 'UPDATE_CARD_STATUS_ERROR';
export const UPDATE_CARD_STATUS_END = 'UPDATE_CARD_STATUS_END';
export const CLEAR_UPDATE_CARD_STATUS_STORE =
  'CLEAR_UPDATE_CARD_STATUS_STORE';
